"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _button = _interopRequireDefault(require("../../../../../core/button"));
var _reinstateModal = _interopRequireDefault(require("./reinstate-modal"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // This displays the appropriate button to allow the user to reinstate entries that have not been refunded.
class ReinstateEntry extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      reinstateRequested: false,
      isProcessing: false
    });
    _defineProperty(this, "_onToggleRequest", () => {
      this.setState({
        reinstateRequested: !this.state.reinstateRequested
      });
    });
    _defineProperty(this, "_onConfirmReinstatement", () => {
      if (this.props.entry.refundID) {
        this.props.onRevertRefundAndReinstateEntries(this.props.entry.refundID);
      } else {
        this.props.onReinstateEntry(this.props.entry.id);
      }
    });
  }
  render() {
    const entry = this.props.entry;
    const displayReinstate = entry.entryStatusRef === 'CANN' || entry.entryStatusRef === 'CANR';
    return /*#__PURE__*/_react.default.createElement("span", null, !displayReinstate ? null : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._onToggleRequest,
      block: true,
      size: "sm"
    }, "Re-Instate"), !this.state.reinstateRequested ? null : /*#__PURE__*/_react.default.createElement(_reinstateModal.default, {
      entry: entry,
      onToggleRequest: this._onToggleRequest,
      onConfirmReinstatement: this._onConfirmReinstatement
    })));
  }

  // *******************************************************************************
  // PartialQuery definition
  // *******************************************************************************
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(ReinstateEntry, "partialQueries", {
  Entry: _mergeBqlQueries({
    id: true,
    isOnlineEntry: true,
    entryStatusRef: true,
    refundID: true
  }, _reinstateModal.default.partialQueries.Entry)
});
var _default = exports.default = (0, _reactBicycle.connect)(ReinstateEntry, undefined, (client, props) => ({
  onReinstateEntry(entryID) {
    return client.update('Entry.reinstateEntry', {
      entryID
    });
  },
  onRevertRefundAndReinstateEntries(refundID) {
    return client.update('Refund.revertRefundAndReinstateEntries', {
      refundID
    });
  }
}));